"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3198],{

/***/ 43198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_WhyUs; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./components/core/Typography/Typography.tsx
var Typography = __webpack_require__(44718);
;// CONCATENATED MODULE: ./components/sections/WhyUs/whyUs.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 3rem;\n    padding-right: 3rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 6.5rem;\n    padding-right: 6.5rem;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 7.5rem;\n    padding-right: 7.5rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 2.5rem;\n    margin: 5rem 0 2rem 0;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 3rem;\n    line-height: 3.5rem;\n    margin: 7.5rem 0 4rem 0;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 5rem;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: row;\n    margin-bottom: 8.75rem;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n    width: 17.6rem;\n    justify-content: normal;\n    margin-bottom: 2.5rem;\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-left: 1.5rem;\n  "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-left: 0;\n  "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 0.5rem;\n  "
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 2.5rem;\n    margin-bottom: 1rem;\n  "
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    line-height: 2rem;\n  "
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}




const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "eaecius0"
})(mixins/* defaultContainerSize */.sX, ";display:flex;flex-direction:column;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h1", {
    target: "eaecius1"
})(Typography/* Header2 */.zV, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";margin:4rem 0 2rem 0;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())), ";");
const Reasons = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eaecius2"
})("display:flex;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";justify-content:space-between;flex-direction:column;margin-bottom:2rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject6())), ";");
const Reason = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eaecius3"
})("position:relative;margin-bottom:2rem;display:flex;justify-content:space-between;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject7())), ";");
const TextContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eaecius4"
})("margin-left:1rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject8())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject9())), ";");
const ImageWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eaecius5"
})("width:4rem;height:4rem;");
const ReasonTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "eaecius6"
})(Typography/* Headline4 */.Ou, ";margin-top:0;margin-bottom:0.25rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject10())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject11())), ";");
const ReasonDescription = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "eaecius7"
})(Typography/* ParagraphS */.fw, ";line-height:1.5rem;letter-spacing:0.013rem;margin:0;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject12())), ";");

;// CONCATENATED MODULE: ./components/sections/WhyUs/WhyUs.tsx





const WhyUs = (param)=>{
    let { title , reasons , titleAs  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                as: titleAs,
                children: title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Reasons, {
                children: reasons.map((reason, index)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Reason, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                    ...(0,imageSerializer/* imageSerializer */.l)(reason.image)
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TextContainer, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReasonTitle, {
                                        children: reason.title
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReasonDescription, {
                                        children: reason.description
                                    })
                                ]
                            })
                        ]
                    }, index))
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/WhyUs/index.ts

/* harmony default export */ var sections_WhyUs = (WhyUs);


/***/ })

}]);